import pkceChallenge from "pkce-challenge";
import { jwtDecode } from "jwt-decode";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const generatePKCE = async () => {
  const challenge = await pkceChallenge();
  const code_challenge = challenge.code_challenge;
  const code_verifier = challenge.code_verifier;
  localStorage.setItem("pkce_verifier", code_verifier);
  return code_challenge;
};

//Logout Function
export async function logout() {
  const keycloakBase = "http://localhost:8080";
  const realm = "master";
  const clientId = "admin-cli";

  const refreshToken = localStorage.getItem("refresh_token");

  // Remove tokens from storage before or after
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("code_verifier");
  sessionStorage.removeItem("code_verifier");

  if (!refreshToken) {
    console.warn("No refresh token found");
    return;
  }

  try {
    await fetch(
      `${keycloakBase}/realms/${realm}/protocol/openid-connect/logout`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          client_id: clientId,
          refresh_token: refreshToken,
        }),
      }
    );

    // User stays on your app; navigate manually if needed
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login";
  } catch (error) {
    console.error("Logout failed:", error);
  }
}

export async function scheduleAutoLogout() {
  const token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token")

  //console.log("TOKEN -> ", token)
  //console.log("REFRESH -> ", refreshToken)
  if (!token || !refreshToken) return;

  try {
    const response = await fetch(
      BASE_URL +`/identity_manager/api/v1/validate?token=${encodeURIComponent(token)}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Server error: ${response.status}`);
    }

    const isValid: boolean = await response.json();

    if (!isValid) {
      console.log("Token is invalid or expired. Logging out.");
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/login";
    } else {
      console.log("Token is valid.");
      sessionStorage.setItem("access_token", token)
      sessionStorage.setItem("refresh_token", refreshToken)
      // Optional: schedule next check or just leave it
    }
  } catch (error) {
    console.error("Failed to validate token:", error);
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login";
  }
}

export function logedInUser() {
  const token = localStorage.getItem("access_token");
  if (!token) return;

  const decoded: any = jwtDecode(token);
  const username = decoded.preferred_username;
  //console.log("Preferred Username:", username);
  return username;
}
